import LowStockRenderer from './Renderer/LowStockRenderer';
import OverstockRenderer from './Renderer/OverstockRenderer';
import BatchExpirationRenderer from './Renderer/BatchExpirationRenderer';
import InventaireRenderer from './Renderer/InventaireRenderer';
import AppointmentReminderRenderer from './Renderer/AppointmentReminderRenderer';

const NotificationRenderer = ({ notification }) => {
  const { code, data } = notification;

  switch (code) {
    case "low_stock":
      return <LowStockRenderer data={data} />;
    case "overstock":
      return <OverstockRenderer data={data} />;
    case "batch_expiration":
      return <BatchExpirationRenderer data={data} />;
    case "inventaire_tournant":
      return <InventaireRenderer notification={notification} />;
    case "appointment_reminder":
      return <AppointmentReminderRenderer data={data} />;
    default:
      return <div>Notification: {code}</div>;
  }
};

export default NotificationRenderer;